<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-head">
      <h2>员工归属</h2>
      <p>管理员统一维护员工所属分部；成交核算会固化当时归属</p>
    </div>
    <el-card shadow="never">
      <el-table
        v-loading="loading"
        :data="rows"
      >
        <el-table-column
          prop="name"
          label="员工"
        />
        <el-table-column
          prop="account"
          label="账号"
        />
        <el-table-column
          prop="branch_name"
          label="当前分部"
        />
        <el-table-column
          prop="team_name"
          label="佣金小组"
        />
        <el-table-column label="角色">
          <template #default="{ row }">
            {{ row.is_group_leader ? '组长' : '成员' }}
          </template>
        </el-table-column>
        <el-table-column
          label="修改分部"
          width="240"
        >
          <template #default="{ row }">
            <el-select
              :model-value="row.organization_unit_id"
              clearable
              @change="(v) => assign(row, v)"
            >
              <el-option
                v-for="b in branches"
                :key="b.id"
                :label="b.name"
                :value="b.id"
              />
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { organizationApi } from '../api'
const rows = ref([]),
  branches = ref([]),
  loading = ref(false)
const load = async () => {
  loading.value = true
  try {
    const result = await Promise.all([
      organizationApi.employees(),
      organizationApi.branches(),
    ])
    rows.value = result[0]
    branches.value = result[1]
  } finally {
    loading.value = false
  }
}
const assign = async (r, v) => {
  try {
    await organizationApi.assignEmployee(r.id, v)
    ElMessage.success('员工分部已更新')
    load()
  } catch (e) {
    ElMessage.error(e?.message || '更新失败')
  }
}
onMounted(load)
</script>
<style scoped>
.page-head {
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8492a6;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
</style>
